import "@/App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import ChainPage from "@/pages/ChainPage";
import History from "@/pages/History";
import Leaderboard from "@/pages/Leaderboard";
import Referrals from "@/pages/Referrals";
import Profile from "@/pages/Profile";
import Legal from "@/pages/Legal";

function App() {
  return (
    <div className="App grain">
      <HashRouter>
        <Routes>
          <Route path="/"               element={<Landing />} />
          <Route path="/markets/evm"    element={<ChainPage chain="evm" />} />
          <Route path="/markets/solana" element={<ChainPage chain="solana" />} />
          <Route path="/history"        element={<History />} />
          <Route path="/leaderboard"    element={<Leaderboard />} />
          <Route path="/referrals"      element={<Referrals />} />
          <Route path="/profile"        element={<Profile />} />
          <Route path="/legal"          element={<Legal />} />
        </Routes>
      </HashRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0e0e0e",
            border: "1px solid #353535",
            color: "#fff",
            fontFamily: "IBM Plex Sans, sans-serif",
            borderRadius: 6,
          },
        }}
      />
    </div>
  );
}

export default App;
